import { Grid, useMediaQuery } from "@mui/material";
import { Visibility } from "@mui/icons-material";
import { useAccount } from "wagmi";

import { Breadcrumbs, PageHeader } from "@dzambalaorg/mui-page-layout";
import { ListAction, ListActions, ListItem, StyledPagination } from "@framework/styled";
import { ContractStatus, ILotteryRound, TokenStatus } from "@framework/types";
import { WithCheckPermissionsListWrapper, LotteryReleaseButton, LotteryRoundEndButton } from "@framework/shared";
import { useDialogView, useFetchQuery } from "@dzambalaorg/react-hooks";
import { IPaginationResult } from "@dzambalaorg/types-collection";
import { List } from "@dzambalaorg/ui-kit";

import { LotteryRoundDialogView } from "./view";

const LOTTERY_ROUNDS_URL = "/lottery/rounds";
const LOTTERY_ROUNDS_VIEW_DIALOG_KEY = "lotteryRounds";

export const LotteryRounds = () => {
  const isMd = useMediaQuery(theme => theme.breakpoints.down("md"));

  const { data, isLoading, isError, take, skip, onChangePage, hasNextPage, loadMoreRef, allRows, totalCount, refetch } =
    useFetchQuery<IPaginationResult<ILotteryRound>>(LOTTERY_ROUNDS_URL, { enableInfiniteScroll: isMd }, void 0, {
      tokenStatus: [TokenStatus.MINTED],
    });

  const { viewItem, handleView, viewDialogUniqueKey, closeViewDialog, viewMode } = useDialogView<ILotteryRound>();

  const { address: account = "" } = useAccount();

  return (
    <Grid>
      <Breadcrumbs path={["dashboard", "lottery", "lottery.rounds"]} />

      <PageHeader message="pages.lottery.rounds.title" />

      <WithCheckPermissionsListWrapper
        isLoading={!data && isLoading}
        isError={!data && isError}
        isEmpty={allRows.length === 0}
        count={allRows.length}
      >
        {allRows.map(round => (
          <ListItem key={round.id} account={account} contract={round.contract}>
            <List.ItemText sx={{ width: 0.2 }}>
              {round.contract?.title} #{round.roundId}
            </List.ItemText>
            <ListActions>
              <ListAction
                onClick={handleView(LOTTERY_ROUNDS_VIEW_DIALOG_KEY, round, "view")}
                message="form.tips.view"
                icon={Visibility}
              />
              <LotteryReleaseButton round={round} onRefreshPage={refetch} />
              <LotteryRoundEndButton
                contract={round.contract}
                disabled={
                  round.contract!.contractStatus === ContractStatus.INACTIVE ||
                  round.contract!.parameters.roundId !== round.id
                }
              />
            </ListActions>
          </ListItem>
        ))}
      </WithCheckPermissionsListWrapper>

      {!isMd && totalCount > take && (
        <StyledPagination
          shape="rounded"
          page={skip / take + 1}
          count={Math.ceil(totalCount / take)}
          onChange={onChangePage}
        />
      )}
      {isMd && hasNextPage && <div ref={loadMoreRef} style={{ height: "20px", margin: "20px 0" }} />}

      <LotteryRoundDialogView
        onCancel={closeViewDialog}
        onConfirm={closeViewDialog}
        open={viewDialogUniqueKey === `${LOTTERY_ROUNDS_VIEW_DIALOG_KEY}.${viewMode}`}
        viewItem={viewItem}
      />
    </Grid>
  );
};
